<fgb-mobile-page-header [pageTitle]="'events.page.title'" backButtonLink="/" />
<fgb-banner class="d-lg-block d-none" [title]="'events.page.title' | translate" />

<div class="container mobile-container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
  <div class="mt-3">
    <fgbcl-marketplace-list [isList]="true" [marketplaceItemTypes]="[3, 5]" [eventItemView]="true"></fgbcl-marketplace-list>
  </div>
</div>
